// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__b6rYI","header":"MergedInvoice_header__2ZzHC"};